// The signed-in person's profile, shared by every page that needs the role or
// MFA state. One query key so a change (TOTP enrolment) refreshes them all.
import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";
import { useSession } from "./session";

export const ME_KEY = ["me"] as const;

export async function fetchMe() {
  const { data } = await api.GET("/me");
  return data ?? null;
}

export function useMe() {
  const session = useSession();
  return useQuery({ queryKey: ME_KEY, enabled: session.status === "signed-in", queryFn: fetchMe });
}
